import courses from './routes'

export {
  CourseSearch,
  CourseSearchFormContext,
  CreateCourse,
  ELearningContentSearch,
  ELearningContentSearchFormContext,
  ProductSearch,
  ProductSearchFormContext,
} from './components'
export {
  useProductSearchFormContext,
  useSearchCourses,
  useSearchProducts,
  useSearchELearningContent,
  useELearningContentSearchFormContext,
} from './hooks'
export { courseReducer, courseSlice } from './slice'
export type {
  Course,
  CourseSearchFormValues,
  ELearningContent,
  ELearningContentSearchFormValues,
  LanguageSearchFormValues,
  Product,
  ProductSearchFormValues,
  Variant,
} from './types'

export default [...courses] as const
